"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgPinboard = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 24 24", size: size }, props),
        react_1.default.createElement("path", { fill: "currentColor", d: "M22.283 5.314l-3.637-3.637a1.5 1.5 0 00-2.326.256L13.226 7.4a7.63 7.63 0 00-1.766-.2 6.32 6.32 0 00-3.513.755 1.5 1.5 0 00-.3 2.355l6.008 6.009c.335.32.793.475 1.252.427a1.5 1.5 0 001.1-.729 6.783 6.783 0 00.548-5.278l5.472-3.099a1.5 1.5 0 00.256-2.326zM8.071 14.559l-6.5 6.5a1 1 0 000 1.414c.394.382 1.02.382 1.414 0l6.5-6.5a1 1 0 00-1.414-1.414z" })));
};
exports.default = SvgPinboard;
//# sourceMappingURL=Pinboard.js.map